export default function checkOverflow(isVisible) {
    //Makes sure body has overflow:hidden when modals are up. If this doesn't happen and modal is bigger than viewport, there will be a double scrollbar
    //Also adding padding while modal is up equal to scrollbar width so the content doesn't jump around when opening modals

    if (process.env.BROWSER) {

        //Find scrollbar width
        var scrollDiv = document.createElement("div");
        scrollDiv.style.width = "100px";
        scrollDiv.style.height = "100px";
        scrollDiv.style.overflow = "scroll";
        scrollDiv.style.position = "absolute";
        scrollDiv.style.top = "-9999px";
        document.body.appendChild(scrollDiv);
        var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);

        if (isVisible) {
            document.body.classList.add("has-modal");
        } else {
            document.body.classList.remove("has-modal");
        }
    }
}



/** WEBPACK FOOTER **
 ** ./app/src/utils/checkModalOverflow.js
 **/